<div class="base-datos" style="margin-top: -60px;">

    <div class="movil-bd-title">
        <p class="movil-db-seccion"><span class="fa fa-angle-left"></span>&nbsp;&nbsp;<span [routerLink]="['/base-de-datos']" >Regresar</span></p>

        <h2>Catálogo de secciones, distritos y municipios</h2>

    </div>

    <div class="movil-card" style="margin-top: -30px;">
        <div style="padding: 16px;">
            <div class="subtitulo padding-b-50 p-l">
                - Contenido -
            </div>
            <img width="90%" src="../../../../../assets/img/basededatos/movil_contenido.svg" style="margin-top: 30px;"/>
        </div>
        
        <div class="bgAzul py-5 txBlanco bottom-radius" style="margin-top: 10px; padding: 16px;">
            <div class="row">
                <div class="col-12 col-lg-3 mobile-parrafo">
                    <p>
                        Dentro de este archivo .zip, encontrarás dos documentos:
                    </p>
                </div>

                <div class="col-12 col-lg-3 mobile-parrafo">
                    <p class="font-bold">
                        <span style="font-size: 2em;vertical-align: middle;">&#8226;</span> PRES.csv
                    </p>
                </div>

                <div class="col-12 col-lg-3 mobile-parrafo">
                    <p>
                        Corresponde a los datos de identificación de las casillas aprobadas, extraídos de la base de datos; cada línea corresponde a una casilla, están separados por comas. En él se muestra la clave de cada casilla, junto con la información clave de su ubicación. Incluye datos de la entidad, el distrito federal, el distrito local, el municipio y la sección correspondiente.
                    </p>
                </div>

                <div class="col-12 col-lg-3 mobile-parrafo">
                    <p>
                        Los datos son los siguientes:
                    </p>
                </div>

                <div class="col-12 col-lg-3 mobile-parrafo">
                    <p class="font-bold">
                        CLAVE_CASILLA | ID_ESTADO | NOMBRE_ESTADO | ID_DISTRITO_FEDERAL | NOMBRE_DISTRITO_FEDERAL | ID_DISTRITO_LOCAL | NOMBRE_DISTRITO_LOCAL | ID_MUNICIPIO | NOMBRE_MUNICIPIO | SECCION | ID_CASILLA | TIPO_CASILLA | EXT_CONTIGUA | LISTA_NOMINAL
                    </p>
                </div>

                <div class="col-12 col-lg-3 mobile-parrafo">
                    <p class="font-bold">
                        <span style="font-size: 2em;vertical-align: middle;">&#8226;</span> LEEME.txt
                    </p>
                </div>

                <div class="col-12 col-lg-3 mobile-parrafo">
                    <p>
                        Describe a detalle cada uno de los campos que forman el archivo del catálogo.
                    </p>
                </div>

                <div class="col-12 col-lg-3 mobile-parrafo">
                    <p>
                        Puedes seguir las mismas instrucciones de descarga, descompresión y apertura del archivo que para la base de datos. Si no las recuerdas, <span style="text-decoration: underline;">regresa a ellas</span>. 
                    </p>
                </div>

                <div class="col-12 col-lg-3 mobile-parrafo">
                    <p>
                        Este archivo se convierte en una herramienta para realizar análisis cruzados entre datos locales y federales, lo que permite una comprensión más completa de la ubicación y contexto de tu casilla en el contexto político y geográfico.
                    </p>
                </div>

                <div class="col-12 col-lg-3 mobile-parrafo">
                    <p>
                        Descarga el archivo .zip del <span style="text-decoration: underline;">Catálogo de secciones, distritos y municipios.</span>
                    </p>
                </div>

            </div>
        </div>        
    </div>

    <!-- BOTTOM -->
    <div style="width: 100%; height: 30px;">

    </div>
    
</div>